import { composeClassNames } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { CSSProperties, useState } from "react";
import {
  Accordion,
  AccordionCollapse,
  AccordionToggle,
  Button,
  Card,
  Col,
  Row,
} from "react-bootstrap";
import constants from "src/constants";
import getCookieByName from "src/functions/getCookieByName";
import validateAuthToken from "src/functions/validateAuthToken";
import { sButton } from "src/styles/sButton.module.scss";
import { sFormAccordion } from "src/styles/sFormAccordion.module.scss";
import Heading from "./Heading";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  muxAssetId: string;
  lectureId: string;
};

function StreamIntroductionKeys({
  style,
  className,
  muxAssetId,
  lectureId,
}: Props) {
  const { locale: lang } = useRouter();
  const [streamId, setStreamId] = useState(null);

  return (
    <>
      {muxAssetId ? (
        <>
          <Heading
            type="h3"
            className={"stream-instruction"}
            variant="primary"
            title={"Instrukce pro streamování"}
          />
          <Accordion
            // defaultActiveKey={`0`}
            className={composeClassNames([
              sFormAccordion,
              "stream-instruction",
            ])}
          >
            <Card>
              <AccordionToggle eventKey={`0`}>
                <b>Larix</b>
              </AccordionToggle>
              <AccordionCollapse eventKey={`0`}>
                <Row className="p-2">
                  <Col>
                    URL:
                    <br />
                    <code>
                      rtmp://global-live.mux.com:5222/app/
                      {muxAssetId}
                    </code>
                  </Col>
                </Row>
              </AccordionCollapse>
            </Card>
            <Card>
              <AccordionToggle eventKey={`1`}>
                <b>Zoom</b>
              </AccordionToggle>
              <AccordionCollapse eventKey={`1`}>
                <>
                  <Row className="p-2">
                    <Col>
                      Streaming URL:
                      <br />
                      <code>rtmp://global-live.mux.com:5222/app/</code>
                    </Col>
                  </Row>
                  <Row className="p-2">
                    <Col>
                      Streaming key:
                      <br />
                      <code>{muxAssetId}</code>
                    </Col>
                  </Row>
                  <Row className="p-2">
                    <Col>
                      Live streaming URL:
                      <br />
                      <code>{window.location.href}</code>
                    </Col>
                  </Row>
                </>
              </AccordionCollapse>
            </Card>
          </Accordion>
        </>
      ) : (
        !streamId && (
          <Button
            variant="primary"
            size="lg"
            className={composeClassNames([sButton])}
            onClick={() =>
              fetch(
                `${constants.Paths.apiUrl}/lectures/generate-stream/${lectureId}`,
                {
                  method: "GET",
                  headers: validateAuthToken(getCookieByName(`auth-token`)),
                }
              ).then(async (res) => {
                if (res.ok) {
                  setStreamId(await res.text());
                }
              })
            }
          >
            Generovat stream
          </Button>
        )
      )}
      {!muxAssetId && streamId !== null && (
        <>
          <Heading
            type="h3"
            className={"stream-instruction"}
            variant="primary"
            title={"Instrukce pro streamování"}
          />
          <Accordion
            // defaultActiveKey={`0`}
            className={composeClassNames([
              sFormAccordion,
              "stream-instruction",
            ])}
          >
            <Card>
              <AccordionToggle eventKey={`0`}>
                <b>Larix</b>
              </AccordionToggle>
              <AccordionCollapse eventKey={`0`}>
                <Row className="p-2">
                  <Col>
                    URL:
                    <p>
                      <code>
                        rtmp://global-live.mux.com:5222/app/
                        {streamId}
                      </code>
                    </p>
                  </Col>
                </Row>
              </AccordionCollapse>
            </Card>
            <Card>
              <AccordionToggle eventKey={`1`}>
                <b>Zoom</b>
              </AccordionToggle>
              <AccordionCollapse eventKey={`1`}>
                <>
                  <Row className="p-2">
                    <Col>
                      Streaming URL:
                      <p>
                        <code>rtmp://global-live.mux.com:5222/app/</code>
                      </p>
                    </Col>
                  </Row>
                  <Row className="p-2">
                    <Col>
                      Streaming key:
                      <p>
                        <code>{streamId}</code>
                      </p>
                    </Col>
                  </Row>
                  <Row className="p-2">
                    <Col>
                      Live streaming URL:
                      <p>
                        <code>{window.location.href}</code>
                      </p>
                    </Col>
                  </Row>
                </>
              </AccordionCollapse>
            </Card>
          </Accordion>
        </>
      )}
    </>
  );
}

export default StreamIntroductionKeys;
